// ─────────────────────────────────────────────────────────────────────────────
// AI PERSONALITIES REGISTRY
// This is the extensibility layer. Every AI agent in the system is defined here.
// The UI reads this registry and auto-renders tabs, filters, and data columns.
// To add a new AI personality later, just add a new object to this array.
// ─────────────────────────────────────────────────────────────────────────────

const AI_PERSONALITIES = [
  {
    id: "sam_scorer",
    name: "SAM Scout",
    description: "Crawls SAM.gov, scores federal opportunities against your company's profile",
    icon: "◎",
    color: "#2196f3",                    // accent color for this personality
    status_endpoint: "/api/status",
    data_endpoint: "/api/opportunities?format=table&stage=scored",
    activity_endpoint: "/api/activity",
    trigger_endpoint: "/api/run",
    // Response Date moved to position 2 — it's the most operationally-critical
    // column for BD professionals. A row without an actionable deadline is
    // useless for them; surface it right next to the title so it's the first
    // thing they read after the opportunity name.
    columns: [
      { key: "name",              label: "Opportunity",      width: "19%", sortable: true },
      { key: "due_date",          label: "Response Date",    width: "13%", sortable: true, type: "date" },
      { key: "ai_score",          label: "Score",            width: "6%",  sortable: true, type: "score" },
      { key: "recommendation",    label: "Rec",              width: "7%",  sortable: true, type: "recommendation" },
      { key: "action_type",       label: "Action",           width: "7%",  sortable: true, type: "action" },
      { key: "agency",            label: "Agency",           width: "12%", sortable: true },
      { key: "posted_date",       label: "Posted",           width: "8%",  sortable: true, type: "date" },
      { key: "source_badge",      label: "Source",           width: "7%",  sortable: true, type: "source" },
      { key: "contract_value",    label: "Value",            width: "6%",  sortable: true },
      { key: "capture_stage",     label: "Stage",            width: "6%",  sortable: true, type: "capture_stage" },
      { key: "capture_risk",      label: "Risk",             width: "4%",  sortable: true, type: "risk" },
      { key: "attachments",       label: "Docs",             width: "5%",  sortable: false, type: "count" },
    ],
    detail_sections: [                   // what to show when you click into an opportunity
      { key: "summary",           label: "AI Summary",       source: "aiScore.summary" },
      { key: "fit_reasons",       label: "Why It Fits",      source: "fit_reasons",      type: "list" },
      { key: "risks",             label: "Risks",            source: "risks",            type: "list" },
      { key: "win_strategy",      label: "Win Strategy",     source: "win_strategy" },
      { key: "competitors",       label: "Watch",            source: "competitors",      type: "list" },
    ]
  },

  // ── ADD NEW PERSONALITIES HERE ──────────────────────────────────────────
  // Example: USAspend Analyst
  // {
  //   id: "usaspend_analyst",
  //   name: "Spend Analyst",
  //   description: "Analyzes historical agency spend patterns to predict upcoming awards",
  //   icon: "▲",
  //   color: "#e5a000",
  //   status_endpoint: "/api/usaspend/status",
  //   data_endpoint: "/api/usaspend/insights?format=table",
  //   activity_endpoint: "/api/usaspend/activity",
  //   trigger_endpoint: "/api/usaspend/run",
  //   columns: [...],
  //   detail_sections: [...]
  // },
  //
  // Example: Competitive Intel
  // {
  //   id: "comp_intel",
  //   name: "Comp Intel",
  //   ...
  // }
];

export default AI_PERSONALITIES;
